import * as React from "react";
import * as moment from "moment";
import {Instalment, InstalmentsInfo, resourcesHelper, D_MMM_YYYY_DATE_FORMAT, INSTALMENT_STATUS_PENDING_PAYMENT} from "@falcon/services";
import { InfoModal } from "../modals/InfoModal";
import { PricingExplainedInfo } from "../PricingExplainedInfo";
import { getAmountToDisplay } from "../../CommonFunctions";

interface IProps {
    showInfoModal: boolean,
    smallScreenMarginRequired?: boolean,
    paymentDate: moment.Moment,
    instalmentsInfo: InstalmentsInfo
}

export class NextPaymentBanner extends React.Component<IProps> {

    private static renderInfoModal(): React.ReactNode {
        return (
            <InfoModal title="Pricing explained">
                <PricingExplainedInfo/>
            </InfoModal>
        );
    }

    public render(): React.ReactNode {
        const additionalWording: string = this.getChangePaymentDayWording(this.props.instalmentsInfo);
        const nextInstalment: Instalment[] = this.props.instalmentsInfo.instalments
            .filter((instalment: Instalment) =>
                moment(instalment.dueDate).isSame(this.props.paymentDate) && !instalment.description.includes("Deposit"));

        if (nextInstalment[0]) {
            return (
                <div className={`banner ${this.props.smallScreenMarginRequired ? "small-screen-margin" : ""}`}>
                    {this.props.showInfoModal && NextPaymentBanner.renderInfoModal()}
                    {!this.props.showInfoModal && <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="info-icon"/>}
                    <div className="banner-text">
                        Your next instalment of{' '}
                        <span className="font-weight-bold"
                              id="next-payment-amount">{getAmountToDisplay(nextInstalment[0].amount)} </span>
                        is due on {this.props.paymentDate.format(D_MMM_YYYY_DATE_FORMAT)}.
                        {additionalWording}
                    </div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }

    private getChangePaymentDayWording(instalmentsInfo: InstalmentsInfo): string {
        let additionalWording: string = "";

        const pendingPaymentInstalments: Instalment[] = instalmentsInfo.instalments.filter(
            (instalment: Instalment) => instalment.status === INSTALMENT_STATUS_PENDING_PAYMENT && !instalment.description.includes("Deposit"));
        const dueDates: Date[] = pendingPaymentInstalments.map((instalment: Instalment) => new Date(instalment.dueDate));

        if (dueDates.length >= 1) {
            const nextDueDate: Date = dueDates[0];
            const afterNextDueDate: Date = dueDates[1];

            if (nextDueDate && afterNextDueDate && moment(nextDueDate).month() === moment().month() && moment(nextDueDate).date() > moment().date()
                && moment(nextDueDate).date() !== moment(afterNextDueDate).date()) {

                additionalWording = " Future payments will be collected on your new chosen date.";
            }
        }

        return additionalWording;
    }
}
